import React, { useEffect, useRef, useState } from "react";
import { useProvider } from "../context/MenuProvider";
import { Row, Col, Card, Button, InputGroup } from "react-bootstrap";

const IMPRESSORA = "https://chatgpt.com/share/68a56beb-eddc-800e-a7d4-1d700f863870";


const PainelLoja = () => {
  const audioRef = useRef(null);
  const [pedidos, setPedidos] = useState([]);
  const { salvarDados, buscarDados } = useProvider();

  const tocarAudio = () => {
    if (!audioRef.current) {
      audioRef.current = new Audio("/som.wav");
      audioRef.current.loop = true;
    }
    
    if (audioRef.current.paused) {
      audioRef.current.play().catch((e) => {
        console.error("Erro ao tentar tocar o áudio:", e);
      });
    }
  };
  
  const pararAudio = () => {
    if (audioRef.current && !audioRef.current.paused) {
      audioRef.current.pause();
      audioRef.current.currentTime = 0;
    }
  };

  const trocarStatusPedido = async (item, novoStatus) => {
    setPedidos((prev) =>
      prev.map((p) => (p.id === item.id ? { ...p, status: novoStatus } : p))
    );
    // aqui você pode salvar no banco também se quiser
    await salvarDados("db_pedidos", { ...item, status: novoStatus });
  };

  useEffect(() => {
    const buscarPedidosLocal = async () => {
      try {
        const hoje = new Date();
        hoje.setHours(23, 59, 59, 999);
    
        const inicioHoje = new Date();
        inicioHoje.setHours(0, 0, 0, 0);
    
        const response = await buscarDados(
          "db_pedidos",
          (item) => {
            const dataPedido = new Date(item.data_do_pedido);
    
            if (item.status === "finalizado" || item.status === "cancelado") {
              // só pega se for do dia de hoje
              return dataPedido >= inicioHoje && dataPedido <= hoje;
            }
    
            // outros status: pega até hoje
            return dataPedido <= hoje;
          },
          200,
          "data_do_pedido",
          "asc"
        );
    
        if (response && response.length) {
          setPedidos(response);
        }
      } catch (err) {
      } finally {
        consultarNovosPedidos();
      }
    };
    
    const consultarNovosPedidos = async () => {
      try{
        const temNovoPedido = Math.random() > 0.5;
        if (temNovoPedido) {
          tocarAudio();
          const itens = [
            { quantidade: 4, nome: "Morango doce", preco: "14.76" },
            { quantidade: 1, nome: "Coca Cola em Lata 2l", preco: "10.76" },
          ];
          const frete = 5.67;
          const total =
            frete +
            itens.reduce(
              (acc, x) =>
                acc +
                parseInt(x.quantidade) * parseFloat(x.preco.replace(",", ".")),
              0
            );
          const pedido = {
            id: Date.now(),
            cliente: `Cliente ${Math.random()}`,
            telefone: `Tel: ${Math.random()}`,
            endereco: `Rua teste bairro testee n°${Math.random()}`,
            itens,
            frete: frete.toFixed(2),
            total: total.toFixed(2),
            pago: false,
            forma_de_pagamento: "pix",
            status: "aguardando",
            data_do_pedido: new Date().toLocaleString("sv-SE"),
          };
          setPedidos((prev) => [...prev, pedido]);
          await salvarDados("db_pedidos", pedido);
        }
      }catch(err){
        
      }finally{
        
      }
    };

    const interval = setInterval(() => {
      buscarPedidosLocal();
    }, 10000);

    buscarPedidosLocal();
    
    return () => {
      clearInterval(interval);
      pararAudio();
    };
  }, []);

  // Lista dos status que você quer exibir
  const statusList = {
    aguardando: "Aguardando",
    em_atendimento: "Em Atendimento",
    aguardando_retirada: "Aguardando Retirada",
    em_entrega: "Em Entrega",
    finalizado: "Finalizado",
    cancelado: "Cancelado",
  };

  // Função que gera os botões dependendo do status
  const renderButtons = (pedido) => {
    switch (pedido.status) {
      case "aguardando":
        return (
          <>
            <Button
              size="sm"
              variant="primary"
              onClick={() => {trocarStatusPedido(pedido, "em_atendimento"); pararAudio(); }}
              className="me-2"
            >
              Atender
            </Button>
            <Button
              size="sm"
              variant="danger"
              onClick={() => {trocarStatusPedido(pedido, "cancelado"); pararAudio();}}
            >
              Cancelar
            </Button>
          </>
        );

      case "em_atendimento":
        return (
          <>
            <Button
              size="sm"
              variant="success"
              onClick={() =>
                trocarStatusPedido(
                  pedido,
                  Math.random() > 0.5 ? "aguardando_retirada" : "em_entrega"
                )
              }
            >
              Próximo
            </Button>
          </>
        );

      case "aguardando_retirada":
      case "em_entrega":
        return (
          <>
            <Button
              size="sm"
              variant="success"
              onClick={() => trocarStatusPedido(pedido, "finalizado")}
              className="me-2"
            >
              Finalizar
            </Button>
            <Button
              size="sm"
              variant="danger"
              onClick={() => trocarStatusPedido(pedido, "cancelado")}
            >
              Cancelar
            </Button>
          </>
        );

      case "cancelado":
        return (
          <Button
            size="sm"
            variant="warning"
            onClick={() => trocarStatusPedido(pedido, "em_atendimento")}
          >
            Resgatar
          </Button>
        );

      default:
        return null;
    }
  };

  return (
    <>
      <h3>Painel Loja</h3>
      <p>Novos pedidos: {pedidos.length}</p>
      
      <InputGroup>
        <Button 
          size="sm"
          variant="success"
          onClick={tocarAudio}
        >
          ▶️ Tocar áudio
        </Button>
        <Button 
          size="sm"
          variant="danger"
          onClick={pararAudio}
        >
          ⏹️ Parar áudio
        </Button>
      </InputGroup>

      <Row>
        {Object.entries(statusList).map(([status, label]) => (
          <Col key={status} xs={12} md={6} className="mb-3">
            <h5>{label}</h5>
            {pedidos
              .filter((p) => p.status === status)
              .map((p) => (
                <Card key={p.id} className="mb-2">
                  <Card.Body>
                    <Card.Title>#{p.id}</Card.Title>
                    <Card.Text>
                      Cliente: {p.cliente} <br />
                      Total: R$ {p.total} <br />
                      Endereço: {p.endereco}
                    </Card.Text>
                    <InputGroup>{renderButtons(p)}</InputGroup>
                  </Card.Body>
                </Card>
              ))}
          </Col>
        ))}
      </Row>
    </>
  );
};

export default PainelLoja;